var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 6.50065H7.33334V5.16732H8.66667V6.50065ZM8.66667 11.834H7.33334V7.83398H8.66667V11.834ZM8 1.83398C7.12452 1.83398 6.25762 2.00642 5.44878 2.34145C4.63994 2.67649 3.90501 3.16755 3.28596 3.78661C2.03571 5.03685 1.33334 6.73254 1.33334 8.50065C1.33334 10.2688 2.03571 11.9645 3.28596 13.2147C3.90501 13.8338 4.63994 14.3248 5.44878 14.6598C6.25762 14.9949 7.12452 15.1673 8 15.1673C9.76811 15.1673 11.4638 14.4649 12.714 13.2147C13.9643 11.9645 14.6667 10.2688 14.6667 8.50065C14.6667 7.62517 14.4942 6.75827 14.1592 5.94943C13.8242 5.14059 13.3331 4.40566 12.714 3.78661C12.095 3.16755 11.3601 2.67649 10.5512 2.34145C9.74239 2.00642 8.87548 1.83398 8 1.83398V1.83398Z",
    fill: "#F7A500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.ecb4615c377fbbf83843ec9429218d4f.svg";
export { ForwardRef as ReactComponent };